/* eslint-disable jsx-a11y/anchor-is-valid */
import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLayout } from '../../../../providers/Layout.provider';
import { useToken } from '../../../../providers/Token.provider';
import { usePaylink } from '../../../../providers/Paylink.provider';
import { useFlexiblePayment } from '../../../../providers/FlexiblePayment.provider';
import FlexibleInfoContext, { FlexibleInfoCtx } from './Dialogue/FlexibleInfoContext';
import FlexibleInfoDialogue from './Dialogue/FlexibleInfoDialogue';
import { FlexibleInfoDialogueHandler, DialogueHandlerProps } from './Dialogue/types';
import styles from './FlexiblePaymentOptions.module.scss';
import BrandingLogo from '../../../UI/BrandingLogo/BrandingLogo';

const { Box, Title, Button, Term } = vp;

type FC = FunctionComponent;

const FlexiblePaymentOptions: FC = () => {
  const { color, setLayoutInfo } = useLayout();
  const { token, isSetByBrowser } = useToken();
  const [showInfo, setShowInfo] = useState(false);
  const { resetPaymentMethod } = useFlexiblePayment();
  const { paylink } = usePaylink();
  const flexibleInfoContext: FlexibleInfoCtx = {
    showInfo,
  };
  const { t } = useTranslation('translations', { keyPrefix: 'FlexiblePaymentOptions' });
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'curve',
      '',
      70,
      32,
      0,
      !isSetByBrowser,
      true,
    );
    resetPaymentMethod();
  }, []);
  const handleFlexibleInfoDialogue = (handlerProps: DialogueHandlerProps<FlexibleInfoDialogueHandler>) => {
    const { type, state, action = 'default' } = handlerProps;

    const dialogueHandlers: FlexibleInfoDialogueHandler = {
      info: {
        fail: {
          default: () => {
            setShowInfo(false);
          },
        },
      },
    };
    const dialogueState = dialogueHandlers[type][state];
    const handler = dialogueState[action] || dialogueState.default;
    handler();
  };

  return (
    <FlexibleInfoContext.Provider value={flexibleInfoContext}>
      <Box jc="center">
        <Box flx="col" ai="center" jc="center" maxwidth="545px">
          <Box height="auto">{token?.BrandingDetails?.Logo && <BrandingLogo src={token?.BrandingDetails?.Logo} />}</Box>
          <Box pt="lg" height="auto">
            <Title title={`${t('title')}`} size="lg" bold />
          </Box>
          <Box flx="col" gap="md" pt="md" pb="md" width="90%" height="auto">
            {hasPaymentOption('multiple') && (
              <Link to={{ pathname: '/connect/flexible-payment/multiple-payment-methods' }}>
                <Button
                  id="push-to-card-button"
                  label={`${t('multiplePaymentMethods')}`}
                  type="submit"
                  background={color}
                  textColor={vp.getContrastColor(color)}
                  width="100%"
                  height="48px"
                  round
                  bold
                  noShadow
                  textSize={1}
                />
              </Link>
            )}
            {hasPaymentOption('partial') && (
              <Link to={{ pathname: '/connect/flexible-payment/partial-payments' }}>
                <Button
                  id="push-to-card-button"
                  label={`${t('partialPayments')}`}
                  type="submit"
                  background={color}
                  textColor={vp.getContrastColor(color)}
                  width="100%"
                  height="48px"
                  round
                  bold
                  noShadow
                  textSize={1}
                />
              </Link>
            )}
            {hasPaymentOption('installments') && (
              <Link to={{ pathname: '/connect/flexible-payment/installment-plan' }}>
                <Button
                  id="push-to-card-button"
                  label={`${t('installmentPlans')}`}
                  type="submit"
                  background={color}
                  textColor={vp.getContrastColor(color)}
                  width="100%"
                  height="48px"
                  round
                  bold
                  noShadow
                  textSize={1}
                />
              </Link>
            )}
          </Box>
          <Box pb="md" height="auto">
            <a
              href="#"
              className={styles.LearnMore}
              onClick={() => {
                setShowInfo(true);
              }}
            >{`${t('learnMore')}`}</a>
          </Box>
          <Term center term={`${t('secure')}`} />
        </Box>
      </Box>
      <FlexibleInfoDialogue handleDialogue={handleFlexibleInfoDialogue} />
    </FlexibleInfoContext.Provider>
  );
  function hasPaymentOption(option: string): boolean {
    return !!paylink?.FlexiblePaymentOptions && paylink?.FlexiblePaymentOptions.includes(option);
  }
};

export default FlexiblePaymentOptions;
